"use client";
import { OnLoginSucceededArgs, auth, safeRequest } from "@osn/auth";
import { AccountService, ApiRequestOptions, CheckService } from "osn-participantapi-client";

export default async function onBeforeSessionSave(
  payload: OnLoginSucceededArgs,
  changedEmail: boolean = false,
): Promise<OnLoginSucceededArgs> {
  await safeRequest({ callback: (options: ApiRequestOptions) => CheckService.checkAccountAccess(options) });

  await auth.currentUser!.getIdToken(true);

  if (changedEmail) {
    const accountCallback = (options: ApiRequestOptions) =>
      AccountService.updateAccountEmail(options, auth.currentUser!.email!);
    await safeRequest({ callback: accountCallback });
  }

  return payload;
}
